<template>
	<div>
		<div class="unit-box" :class="{'z-dis': !editable}" :style="{'width': full ? 'auto' : '1400px'}" @dblclick="unitEdit">
			<div class="unit-content">
				<slot></slot>
			</div>
			<div class="unit-tool flex-center-cross" @dblclick.stop>
				<template v-if="deleteButton">
					<a v-if="index != 0" @click="sortHandle(-1)"><i class="tf tf-sort-up"></i></a>
					<a v-if="after && after.load_type != 2" @click="sortHandle(1)"><i class="tf tf-sort-down"></i></a>
				</template>
				<button v-if="deleteButton" @click="removeHandle">删除</button>
				<!-- <c-switch v-if="switchButton" :value="active" text="显示,隐藏" @change="changeHandle"></c-switch> -->
			</div>
		</div>
		
		<c-dialog v-if="config && editState" ref="edit" :fadein="false" :title="name" width="500" @resolve="submitHandle" @close="editFinish">
			<ul class="unit-edit-tab flex">
				<li v-for="(item, i) in config" :key="i" :class="{'z-crt': currentTab == i}" @click="currentTab = i">{{item.tab}}</li>
			</ul>
			<div v-show="currentTab == i" v-for="(item, i) in config" :key="i" class="unit-edit-content">
				<p v-if="item.tips" class="unit-edit-tips">{{item.tips}}</p>
				<unit-edit-form ref="form" :config="item.content"></unit-edit-form>
			</div>
		</c-dialog>
		
		<c-dialog ref="productSelector" width="810" title="手动选择" @resolve="selectProductHandle">
			<div class="product-select flex-column">
				<m-search ref="productSearch" @search="$refs.productSelectorPagination.update(1)">
					<c-form>
						<c-form-item type="select" label="商品分类" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
						<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
						<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
					</c-form>
				</m-search>
				<ul class="product-tab flex">
					<li :class="{'z-crt': currentProductTab == 1}" @click="currentProductTab = 1">全部</li>
					<li :class="{'z-crt': currentProductTab == 2}" @click="currentProductTab = 2">已选 ({{currentProductList.length}})</li>
				</ul>
				<div v-show="currentProductTab == 1" class="flex-grow flex-column">
					<div class="product-list flex-grow">
						<div class="flex-wrap">
							<div v-for="(item, i) in productList" :key="item.product_id" class="item flex-center" :class="{'z-crt': currentProductId.includes(item.product_id)}" @click="productClickHandle(item)">
								<img :src="item.product_img_url">
								<p class="ellipsis">{{item.product_name}}</p>
								<i class="check tf tf-check"></i>
							</div>
						</div>
					</div>
					<pagination ref="productSelectorPagination" :total="productTotal" :border="false" @handle="updateProductList"></pagination>
				</div>
				<div v-show="currentProductTab == 2" class="product-list flex-grow">
					<draw-sort v-model="currentProductList" ref="productSort">
						<template v-slot="{list}">
							<div class="flex-wrap">
								<draw-item v-for="(item, i) in list" :key="item.product_id" :index="i">
									<div class="item flex-center">
										<img :src="item.product_img_url">
										<p class="ellipsis">{{item.product_name}}</p>
										<i class="remove tf tf-cross" @mousedown.stop @click="productClickHandle(item, true)"></i>
									</div>
								</draw-item>
							</div>
						</template>
					</draw-sort>
				</div>
			</div>
		</c-dialog>
	</div>
</template>

<script>
	import unitEditForm from './unit_edit_form.vue'
	import pagination from '@/components/public/pagination.vue'
	import drawSort from '@/components/draw_sort/index.vue'
	import drawItem from '@/components/draw_sort/item.vue'
	import pcConfig from './unit_edit_config_pc.js'
	import appConfig from './unit_edit_config_app.js'
	
	export default {
		name: 'unitEdit',
		
		components: {
			unitEditForm,
			pagination,
			drawSort,
			drawItem
		},
		
		props: {
			type: String,
			index: Number,
			name: String,
			uid: Number,
			code: String,
			handle: Boolean,
			editable: Boolean,
			switchButton: Boolean,
			deleteButton: Boolean,
			active: Boolean,
			after: Object
		},
		
		data() {
			let data = (this.type == 'app' ? appConfig[this.code] : pcConfig[this.code]) || {};
			return {
				full: this.type == 'app' || ['banner', 'channel_banner', 'channel_image_list', 'code'].includes(this.code),
				config: data.config,
				editState: false,
				currentTab: 0,
				
				currentProductTab: 1,
				productList: [],
				currentProductList: [],
				productTotal: 0
			}
		},
		
		computed: {
			currentProductId() {
				return Array.from(this.currentProductList, item => {
					return item.product_id;
				});
			}
		},
		
		mounted() {
			this.updateUnitData();
		},
		
		methods: {
			updateUnitData() {
				this.request({
					url: '/decoration/page/control/data',
					data: {
						page_control_id: this.uid
					},
					success: data => {
						let $unit = this.$children[0].$children[0];
						if ($unit) {
							$unit.set ? $unit.set(data.control_data) : $unit.unitData = data.control_data;
						}
					}
				});
			},
			
			unitEdit() {
				if (!this.editable) return;
				this.currentTab = 0;
				this.editState = true;
				this.$nextTick(() => {
					this.request({
						url: '/decoration/page/control/config/detail',
						data: {
							page_control_id: this.uid
						},
						loading: true,
						success: data => {
							data = JSON.parse(data.control_configure || '{}');
							console.log(data);
							this.$refs.edit.open();
							this.$refs.form.forEach(item => {
								item.set(data);
							});
						}
					});
				});
			},
			
			sortHandle(step) {
				this.request({
					url: '/decoration/control/sort',
					data: {
						page_control_id: this.uid,
						new_sort_id: this.index + step
					},
					success: () => {
						this.$bus.$emit('updateUnitList');
					}
				})
			},
			
			removeHandle() {
				this.$confirm({
					text: '确定要删除此控件吗？',
					resolve: () => {
						this.request({
							url: '/decoration/control/remove',
							data: {
								page_control_id: this.uid
							},
							loading: true,
							success: () => {
								this.$bus.$emit('updateUnitList');
							}
						})
					}
				})
			},
			
			changeHandle(state, stop, next) {
				stop();
				this.request({
					url: '/decoration/page/control/state/edit',
					data: {
						page_control_id: this.uid,
						state: this.active ? 0 : 1
					},
					success: () => {
						next();
					}
				})
			},
			
			submitHandle: async function(stop, next) {
				stop();
				let data = {};
				for (let i = 0; i < this.$refs.form.length; i++) {
					let temp = await this.$refs.form[i].submit();
					data = Object.assign(data, temp);
				};
				this.request({
					url: '/decoration/page/control/config/edit',
					data: {
						page_control_id: this.uid,
						control_configure: JSON.stringify(data)
					},
					loading: true,
					success: () => {
						this.$message({
							text: '保存成功'
						});
						this.updateUnitData();
						next();
					}
				});
			},
			
			editFinish() {
				setTimeout(() => {
					this.editState = false;
				}, 500);
			},
			
			selectProduct(opt) {
				this._selectProductConfig = opt;
				this.currentProductList = [];
				if (opt.value.length) {
					this.request({
						url: 'product/all/list',
						data: {
							product_ids: opt.value
						},
						success: data => {
							this.currentProductList = data || [];
						}
					});
				}
				this.$refs.productSelectorPagination.update(1);
				this.$refs.productSelector.open();
				this.$nextTick(() => {
					let size = this.$refs.productSelector.$refs.content.getBoundingClientRect();
					this.$refs.productSort.updateTranslate({
						x: -size.width / 2,
						y: -size.height / 2
					})
				});
			},
			
			selectProductHandle(stop, next) {
				stop();
				if (this.currentProductList.length == 0) {
					this.$message({
						text: '请选择商品'
					});
					return;
				}
				next();
				this._selectProductConfig.resolve(Array.from(this.currentProductList, item => {
					return item.product_id;
				}));
			},
			
			updateProductList(data) {
				this.currentProductTab = 1;
				this.request({
					url: '/product/list',
					data: Object.assign(data, this.$refs.productSearch.get()),
					success: data => {
						this.productList = data || [];
					},
					response: res => {
						this.productTotal = res.total;
					}
				});
			},
			
			productClickHandle(item, remove) {
				if (remove || this.currentProductId.includes(item.product_id)) {
					this.currentProductList.splice(this.currentProductId.indexOf(item.product_id), 1);
				} else {
					this.currentProductList.push(item);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.unit {
		&-box {
			position: relative;
			min-height: 38px;
			margin: 0 auto;
			cursor: pointer;
			user-select: none;
			
			&.z-dis:hover {
				&:before {
					background: rgba(0,0,0,.4);
				}
				
				&:after {
					content: '此模块不可编辑';
					color: #FFCB00;
				}
			}
			
			&:hover {
				&:before {
					content: '';
					z-index: 11;
					position: absolute;
					left: 0;
					top: 0;
					right: 0;
					bottom: 0;
					border: 2px dashed #f00;
					background: rgba(154,190,208,.7);
				}
				
				&:after {
					content: '双击编辑内容';
					z-index: 11;
					position: absolute;
					left: 0;
					top: 50%;
					width: 100%;
					font-size: 15px;
					font-weight: bold;
					text-align: center;
					text-shadow: 2px 2px 2px rgba(0,0,0,.6);
					color: #fff;
					transform: translate(0,-50%);
				}
				
				.unit-tool {
					display: block;
				}
			}
		}
		
		&-content {
			position: initial;
			
			>>> .unit-empty {
				line-height: 38px;
				text-align: center;
				color: #999;
			}
		}
		
		&-tool {
			display: none;
			z-index: 12;
			position: absolute;
			right: 0;
			top: 0;
			right: 0;
			height: 30px;
			padding: 5px;
			
			> * {
				margin-left: 10px;
			}
			
			button {
				height: 28px;
				padding: 0 10px;
				border-radius: 2px;
				font-size: 13px;
				color: #fff;
				background: #464847;
				cursor: pointer;
				
				&:hover {
					opacity: .8;
				}
			}
			
			a {
				&:hover {
					opacity: .6;
				}
			}
		}
		
		&-edit {
			&-tab {
				z-index: 1;
				position: sticky;
				top: 0;
				height: 34px;
				border-bottom: 1px solid #ddd;
				background: #F4F4F4;
				
				li {
					height: 34px;
					border: 1px solid #ddd;
					border-width: 0 1px 1px 0;
					padding: 0 17px;
					line-height: 34px;
					cursor: pointer;
					
					&:hover {
						background: #fff;
					}
					
					&.z-crt {
						border-bottom-color: #fff;
						background: #fff;
					}
				}
			}
			
			&-tips {
				z-index: 9;
				position: sticky;
				top: 35px;
				padding: 10px 14px;
				line-height: 18px;
				font-size: 12px;
				color: #f18137;
				background: #fffcf3;
			}
		}
	}
	
	.product {
		&-select {
			height: 550px;
		}
		
		&-tab {
			padding: 0 20px;
			margin-top: -10px;
			
			li {
				position: relative;
				display: inline-block;
				line-height: 40px;
				font-size: 15px;
				color: #333;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 30px;
				}
				
				&.z-crt,
				&:hover {
					font-weight: bold;
				}
				
				&.z-crt:after {
					content: '';
					position: absolute;
					left: 50%;
					bottom: 0;
					width: 30px;
					height: 2px;
					margin-left: -15px;
					background: #000;
				}
			}
		}
		
		&-list {
			padding: 0 20px 20px;
			overflow: auto;
			
			.item {
				position: relative;
				width: 100px;
				height: 100px;
				margin-right: 10px;
				margin-top: 10px;
				outline: 1px solid #ddd;
				cursor: pointer;
				
				&:hover, &.z-crt {
					outline-color: #999;
				}
				
				&.z-crt {
					.check {
						display: block;
					}
				}
				
				.check {
					display: none;
					position: absolute;
					right: 4px;
					top: 4px;
					width: 16px;
					height: 16px;
					border-radius: 8px;
					line-height: 16px;
					font-size: 12px;
					color: #fff;
					text-align: center;
					background: #3dc50b;
				}
				
				.remove {
					position: absolute;
					right: 0;
					top: 0;
					width: 20px;
					height: 20px;
					line-height: 20px;
					font-size: 12px;
					color: #fff;
					text-align: center;
					background: #DE0000;
				}
				
				p {
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					padding: 0 10px;
					line-height: 24px;
					font-size: 12px;
					text-align: center;
					color: #fff;
					background: rgba(0,0,0,.6);
				}
			}
		}
	}
</style>
